export default function formatUrl(url: string): string {
  return url.toLowerCase().replace(' & ', '-and-').replace(/\s/g, '-');
}
